import styled, { css } from 'styled-components';

/** CSS utility to apply line clamping with ellipsis */
export const lineClamp = (lines: number) => css`
  display: -webkit-box;
  -webkit-line-clamp: ${lines};
  -webkit-box-orient: vertical;
  overflow-y: hidden;
  text-overflow: ellipsis;
`;

interface LineClampTextProps {
  lines: number;
}

/** Line clamped paragraph */
export const LineClampText = styled.p<LineClampTextProps>`
  ${({ lines }) => lineClamp(lines)};
`;

LineClampText.displayName = 'LineClampText';
